import { render, staticRenderFns } from "./UjianEventList.vue?vue&type=template&id=566bf3da&scoped=true"
import script from "./UjianEventList.vue?vue&type=script&lang=js"
export * from "./UjianEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bf3da",
  null
  
)

export default component.exports